<ngx-spinner type="pacman">
    <div class="loader"></div>
</ngx-spinner>
<main>
  <!-- Footer (only for after-login routes) -->
   <router-outlet></router-outlet>
</main>

<!-- Notification Display Component -->
<app-notification-display></app-notification-display>
